var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AfyButton, AfyModal } from "@affinitysystemsgroup/assurehub-ui";
import { MODAL_DELETE_CANCEL_LABEL, MODAL_DELETE_CONFIRM_LABEL, MODAL_DELETE_QUESTION, MODAL_DELETE_TITLE, } from "../../../constants/insurances.constants";
import { ModalDeleteButtons, ModalDeleteDescription, } from "../style/modalDelete.style";
var MODAL_PROPS = {
    centered: false,
    size: "md",
};
var BUTTON_PROPS = {
    variant: "filled",
    size: "md",
};
export var ModalDeleteView = function (props) {
    var _a, _b, _c;
    return (_jsxs(AfyModal, __assign({}, MODAL_PROPS, { opened: props.openModalConfirmDelete, onClose: function () { return props.setOpenModalConfirmDelete(false); }, title: "".concat(MODAL_DELETE_TITLE, " ").concat((_b = (_a = props.itemCard) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : "") }, { children: [_jsxs(ModalDeleteDescription, { children: [MODAL_DELETE_QUESTION, " ", _jsx("strong", { children: (_c = props.itemCard) === null || _c === void 0 ? void 0 : _c.title }), "?"] }), _jsxs(ModalDeleteButtons, { children: [_jsx(AfyButton, __assign({}, BUTTON_PROPS, { label: MODAL_DELETE_CANCEL_LABEL, color: "brand", onClick: function () { return props.setOpenModalConfirmDelete(false); } })), _jsx(AfyButton, __assign({}, BUTTON_PROPS, { label: MODAL_DELETE_CONFIRM_LABEL, color: "red", onClick: function () { return props.onClickDelete(props.itemCard); } }))] })] })));
};
